import { useCloudFunction } from './useCloudFunction';
import { dateToNs, nsToDate } from './timestampUtils';
import type { AccountTransfer } from '../types';

type RawTransferRow = Omit<AccountTransfer, 'timestamp' | 'amount'> & {
    timestamp: string;
    amount: number | string;
};

export function useAccountTransfers(
    accountId: string | null,
    from: Date,
    to: Date,
): { data: AccountTransfer[]; loading: boolean; error: Error | null } {
    const params = accountId ? {
        accountId,
        from: dateToNs(from),
        to: dateToNs(to),
    } : null;

    return useCloudFunction<RawTransferRow, AccountTransfer>(
        'loadAccountTransfers',
        params,
        (rows) => rows.map((row) => ({
            ...row,
            amount: Number(row.amount),
            timestamp: nsToDate(row.timestamp),
        })),
    );
}
